export default __webpack_public_path__ + "static/media/70.7b8a36b5.svg";